import {Link, useLocation} from "react-router-dom";
import {dig} from "lib/ext/object";
import useAppContext from "lib/hooks/use-app-context";
import logo from "app/assets/images/logo.png";

const nestedRoutes = {
  validation: {
    home: {name: "Validation", path: "/admin/validation"},
    routes: [
      {name: "Automated", path: "/admin/validation/automated_reports"},
      {name: "Reports", path: "/admin/validation/reports"},
      {name: "Studies", path: "/admin/validation/studies"},
      {name: "Surveys", path: "/admin/validation/surveys"}
    ]
  }
};

export default function Navbar() {
  const {app: {organization}, user} = useAppContext();
  const {pathname} = useLocation();
  const secondaryRoutes = Object.keys(nestedRoutes)
    .filter((key) => nestedRoutes[key].routes.some(({path}) => pathname.startsWith(path)));

  return (
    <>
      <div className="bg-navbar navbar-default">
        <div className="container">
          <div className="flex items-center justify-between">
            <a className="inline-block" href="/">
              <img alt="Logo" src={dig(organization, "logo") || logo} />
            </a>
            {user && (
              <div className="flex items-center gap-4">
                {user.admin && (
                  <nav className="flex gap-3">
                    <Link className="btn-nav" to="/admin/admins">Admins</Link>
                    <Link className="btn-nav" to="/admin/decks">Decks</Link>
                    <Link className="btn-nav" to="/admin/organizations">Organizations</Link>
                    <Link className="btn-nav" to="/admin/validation/reports">Validation</Link>
                  </nav>
                )}
                <a className="btn btn-nav btn-xs" href="/sessions/logout">
                  Logout
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      {secondaryRoutes.map((key) => (
        <div className="bg-navbar" key={key}>
          <div className="container py-2">
            <div className="flex items-center justify-between">
              <Link className="btn-nav" to={nestedRoutes[key].home.path}>{nestedRoutes[key].home.name}</Link>
              <div className="flex flex-wrap gap-4 justify-end">
                {nestedRoutes[key].routes.map((route) => (
                  <Link className="btn-nav" key={route.path} to={route.path}>{route.name}</Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
